// extracted by mini-css-extract-plugin
export default {"headerBar":"MyEmployees_headerBar__a1OO9","action-buttons":"MyEmployees_action-buttons__4N3uu","button-group":"MyEmployees_button-group__Fj7Tg"};